import { OPEN_PREFERENCES_MODAL_QUERY_PARAM } from '../../constants'

// Must be similar names (uppercase) to _templates
export const APP = {
  GRAPHICS: 'graphics',
  AVGEN: 'avgen',
  CLIPRO: 'clipro',
  BQ_PANEL: 'bqpanel',
  HF: 'hf',
  SETTINGS: 'settings',
  PUBLISH_HUB: 'publish_hub',
  PLATFORM_AVGEN: 'platform_avgen',
  LIBRARY: 'library',
  CMS: 'cms',
  BLAZE_CMS: 'blaze_cms',
  PLATFORM_SETTINGS: 'platform_settings',
  PARTNERS_PORTAL: 'partners_portal',
}

export const APPS_SUPPORT_PLATFORM_ROUTER = [
  APP.CLIPRO,
  APP.PUBLISH_HUB,
  APP.LIBRARY,
  APP.CMS,
  APP.PLATFORM_AVGEN,
  APP.BLAZE_CMS,
  APP.PLATFORM_SETTINGS,
]

export const DISPLAY = {
  SHOW: 'SHOW',
  HIDE: 'HIDE',
  DISABLED: 'DISABLED',
  ACTIVE: 'ACTIVE',
}

// Display options as coming from the Settings API
export const SETTINGS_DISPLAY = {
  SHOW: 'Show',
  HIDE: 'Hide',
  DISABLED: 'Disable',
}

export const SETTINGS_APP_ID = 'settings'
export const PLATFORM_SETTINGS_APP_ID = 'platform_settings'
export const USER_MANAGEMENT_APP_ID = 'user_management'
export const USER_ACADEMY_APP_ID = 'user_academy'
export const CHANGE_PASSWORD_ID = 'change_password'

export const THEME_COLOR = {
  [APP.CLIPRO]: '#5aa3ff',
  [APP.PLATFORM_AVGEN]: '#FF354D',
  [APP.AVGEN]: '#ff4e10',
  [APP.GRAPHICS]: '#24c0cc',
  [APP.PUBLISH_HUB]: '#ffffff',
  [APP.LIBRARY]: '#fcc603',
  [APP.CMS]: '#fcc603',
  [APP.BLAZE_CMS]: '#fcc603',
  [APP.PLATFORM_SETTINGS]: '#5aa3ff',
}

export const THEME_COLOR_LIGHT = {
  [APP.CLIPRO]: '#5aa3ff4D',
  [APP.PLATFORM_AVGEN]: 'rgba(255, 53, 77, 0.20)',
  [APP.AVGEN]: '#ff4e104D',
  [APP.GRAPHICS]: '#24c0cc4D',
  [APP.SETTINGS]: '#D4D4D44D',
  [APP.PUBLISH_HUB]: '#D4D4D44D',
  [APP.LIBRARY]: '#fcc6034D',
  [APP.CMS]: '#fcc6034D',
  [APP.BLAZE_CMS]: '#fcc6034D',
  [APP.PLATFORM_SETTINGS]: '#5aa3ff4D',
}

export const DEFAULT_SYSTEM_IMAGE =
  'https://graphicsfeprodeus2.prod-cdn.clipro.tv/static-images/clipro-default-user.jpg'
export const MULTI_SYSTEM_GROUP_IMAGE =
  'https://graphicsfeprodeus2.prod-cdn.clipro.tv/static-images/multisystemicon.png'
export const PLATFORM_SETTINGS_URL = '/platform_settings'
export const SETTINGS_URL = '/avgen?page=settings'
export const CLIPRO_PREFERENCES_URL = `/clipro?${OPEN_PREFERENCES_MODAL_QUERY_PARAM}=true`

export const TRACKER_FAVORITES_CATEGORY = {
  FAVOURITES: 'Favourites',
  GENERAL: 'General',
}

export const TRACKER_CONTACT_US_LABEL = 'contact us button'
export const TRACKER_CONTACT_US_SEND_BUTTON_LABEL = 'send button'
export const TRACKER_SYSTEM_MENU_BUTTON_LABEL = 'system menu button'
export const TRACKER_SYSTEM_MENU_CLOSE_BUTTON_LABEL = 'system menu close button'
export const TRACKER_PREFERENCES_MENU_LABEL = 'preferences menu'
export const TRACKER_UPLOAD_MONITOR_LABEL = 'upload monitor'

export const EXPAND_COLLAPSE_LABELS = {
  EXPAND_ALL: 'Expand All',
  COLLAPSE_ALL: 'Collapse All',
}

export const MINIMAL_NUMBER_OF_PERMISSIONS_FOR_FAVORITES_FEATURE_ENABLED = 6
export const MINIMAL_NUMBER_OF_GROUPS_FOR_COLLAPSE_EXPAND_FEATURE_ENABLED = 2

export const SYSTEMS_LOGOS_LOCAL_STORAGE_KEY = 'WSC_SYSTEMS_LOGOS'

export const USER_PERMISSION_KEYS = {
  SYSTEM: 'system',
  GROUP: 'group',
}

export const CONTACT_US_CONSTANTS = {
  LABEL: 'Contact us',
  FORM: {
    ACTION: 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8',
    METHOD: 'POST',
    TARGET: 'hiddenFrame',
  },
  UTIL_INPUT: {
    ORGID: {
      TYPE: 'hidden',
      NAME: 'orgid',
      VALUE: '00D5e000002GD0p',
    },
    RECORD_TYPE: {
      TYPE: 'hidden',
      NAME: 'recordType',
      VALUE: '0125e000000z7wM',
    },
    SYSTEM_INPUT: {
      TYPE: 'hidden',
      NAME: 'System_Id__c',
    },
    GROUP_INPUT: {
      TYPE: 'hidden',
      NAME: 'Group_Id__c',
    },
  },
  INPUT: {
    HTML_FOR: 'contact-us-email',
    LABEL: 'Email address',
    ID: 'contact-us-email',
    NAME: 'email',
  },
  TEXT_AREA: {
    HTML_FOR: 'contact-us-description',
    LABEL: 'How can we help you?',
    ID: 'contact-us-description',
    NAME: 'description',
  },
}

export const BOTTOM_BUTTON = {
  SETTINGS: 'Settings',
  UPLOADING_MONITOR: 'Uploading_monitor',
}

export const SIDE_BAR_WIDTH = '55px'

export const IS_PRE_CREATE_PARAMETER = 'isPreCreate'
